// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar          from './components/Navbar';
import Footer          from './components/Footer';
import Home            from './pages/Home';
import BookMaintenance from './pages/BookMaintenance';
import Shop            from './pages/Shop';
import Admin           from './pages/Admin';
import BulkImport      from './pages/BulkImport';
import Contact         from './pages/Contact';
import About           from './pages/About';
import NotFound        from './pages/NotFound';

export default function App() {
  return (
    <BrowserRouter>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/"             element={<Home />}            />
            <Route path="/book"         element={<BookMaintenance />}  />
            <Route path="/shop"         element={<Shop />}             />
            <Route path="/admin"        element={<Admin />}            />
            <Route path="/admin/import" element={<BulkImport />}       />
            <Route path="/contact"      element={<Contact />}          />
            <Route path="/about"        element={<About />}            />
            <Route path="*"             element={<NotFound />}         />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
